module.exports = __webpack_public_path__ + "img/StandardWorkTimeDialog.f780990e.png";